import express, { RequestHandler } from 'express';
import { parsePayload } from '~/app/middleware';
import { callbackHandler } from '../middleware/Callback';
import { returnModels } from '../middleware/ContentModels';
import {
  getContentTypes,
  returnComponents,
  returnContentTypes,
} from '~/app/middleware/ContentTypes';
import { returnEntries } from '../middleware/Entries';
import { returnNodes } from '../middleware/Nodes';
import {
  getApiKeys,
  getProjects,
  returnProjects,
} from '../middleware/Projects';
import { getRoles } from '../middleware/Roles';
import { getWebhooks } from '../middleware/Subscriptions';
import { getTagGroups, getTags } from '../middleware/Tags';
import { getWorkflows } from '../middleware/Workflow';

const getRouter = express.Router();

const notImplemented: RequestHandler = (req, res) =>
  res.status(501).send('Not implemented yet');

getRouter.post('/assets{/:id}', parsePayload, notImplemented);
getRouter.post(
  '/components{/:id}',
  parsePayload,
  getContentTypes,
  returnComponents
);
getRouter.post(
  '/contenttypes{/:id}',
  parsePayload,
  getContentTypes,
  returnContentTypes
);
getRouter.post('/entries{/:id}', parsePayload, returnEntries, callbackHandler);
getRouter.post(
  '/entries/all{/:id}',
  parsePayload,
  returnEntries,
  callbackHandler
);
getRouter.post('/keys{/:id}', parsePayload, getApiKeys);
getRouter.post('/models{/:id}', parsePayload, getContentTypes, returnModels);
getRouter.post('/nodes{/:id}', parsePayload, returnNodes, callbackHandler);
getRouter.post('/projects{/:id}', parsePayload, getProjects, returnProjects);
getRouter.post('/roles{/:id}', parsePayload, getRoles);
getRouter.post('/tags{/:id}', parsePayload, getTags, callbackHandler);
getRouter.post('/taggroups{/:id}', parsePayload, getTagGroups, callbackHandler);
getRouter.post('/workflows{/:id}', parsePayload, getWorkflows);
getRouter.post('/webhooks{/:id}', parsePayload, getWebhooks);

export default getRouter;
